import listing from "@/apollo/users/listing.gql";
import change_theme from "@/apollo/users/change_theme.gql";
//import changed_theme from "@/apollo/users/changed_theme.gql";
import fetch_roles from "@/apollo/users/roles.gql";
import create from "@/apollo/users/create.gql";
import user_by_id from "@/apollo/users/user_by_id.gql";
import update_profile_logo from "@/apollo/users/update_logo.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 17 Jun 2023 | 11:35AM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.loading = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 17 Jun 2023 | 11:35AM
   */
  setUsers(state, value) {
    state.list = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 27 Jun 2023 | 12:58PM
   * @param {*} state
   * @param {*} value
   */
  setCreating(state, value) {
    state.creating = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 17 Jun 2023 | 11:35AM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    return new Promise((resolve) => {
      commit("setLoading", true);
      commit("setUsers", []);
      this.$apolloClient
        .query({
          query: listing
        })
        .then(({ data }) => {
          commit("setUsers", data.fetch_users);
          commit("setLoading", false);
          resolve(data.fetch_users);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Jun 2023 | 04:21PM
   * @param {*} __
   * @returns {*}
   */
  fetchRoles(__) {
    return new Promise((resolve) => {
      this.$apolloClient
        .query({
          query: fetch_roles
        })
        .then(({ data }) => {
          resolve(data.fetch_user_roles);
        })
        .catch(() => {});
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 28 Jun 2023 | 04:45PM
   * @param {*} { commit }
   * @param {*} _id
   * @returns {*}
   */
  fetchUserById({ commit }, _id) {
    return new Promise((resolve) => {
      this.$apolloClient
        .query({
          query: user_by_id,
          variables: { _id }
        })
        .then(({ data }) => {
          resolve(data.fetch_user_by_id);
        })
        .catch(() => {});
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 20 Jun 2023 | 12:36PM
   * @param {*} __
   * @param {*} theme
   * @returns {*}
   */
  changeTheme(__, theme) {
    return new Promise((resolve) => {
      this.$apolloClient.mutate({
        mutation: change_theme,
        variables: { theme },
        update: (cache, result) => {
          this.dispatch("auth/fetchCurrentUser");
          resolve(result.change_theme);
        }
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 27 Jun 2023 | 12:55PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  createUser({ commit }, payload) {
    commit("setCreating", true);
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: create, variables: { payload } })
        .then(({ data }) => {
          const _user = this.getters["auth/user"];
          if (payload?._id == _user?._id) {
            this.dispatch("auth/fetchCurrentUser");
          }
          commit("setCreating", false);
          resolve(data.create_user);
        })
        .catch((err) => {
          reject(err);
          this.$graphError(err);
          commit("setCreating", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 18 Jun 2023 | 02:18PM
   * @param {*} __
   * @returns {*}
   */
  refreshUserSettings({ commit }, payload) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription($payload:JSON) { refresh_profile_changes(payload:$payload) }`,
        variables: { payload }
      });
      for await (const event of _result) {
        const _res = event?.data?.refresh_profile_changes;
        if (_res?.success) {
          this.dispatch("auth/fetchCurrentUser");
          //commit("setThemeChanged", _res.data);
        }
      }
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 18 Jul 2023 | 06:17PM
   * @param {*} _
   * @param {*} logo
   * @returns {*}
   */
  updateProfileLogo(_, logo) {
    return new Promise(async (resolve, reject) => {
      const _apollo = await this.$apolloClient.mutate({ mutation: update_profile_logo, variables: { logo } }).then(({ data }) => data);
      resolve(_apollo?.update_profile_logo);
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating
};
